import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./userSlice";
import cateReducer from "./cateSlice";

export const store = configureStore({
  reducer: {
    user: userReducer,
    cate: cateReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
